import styled from 'styled-components';

import { Typography } from '../../display/Typography';

import { LabelProps } from './types';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxxs};
`;

export const Label = styled(Typography)<LabelProps>``;

type textArea = {
  borderError: boolean | undefined;
};

export const Area = styled.textarea<textArea>`
  width: 100%;
  resize: vertical;
  border: solid 0.1rem ${({ theme }) => theme.colors.black};
  border-radius: 0.5rem;
  min-height: 21rem;
  font-size: ${({ theme }) => theme.fontSize.S};
  padding: ${({ theme }) => theme.spacing.xxs} 1rem;
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.white};
  ${(props) =>
    props.disabled && {
      backgroundColor: props.theme.colors.greyLight,
      border: 'transparent',
      color: props.theme.colors.greyDark,
    }}
  border: ${(props) =>
    props.borderError && `0.1rem solid ${props.theme.colors.lightCoralRed}`};

  &:focus {
    outline: 0.08rem solid ${({ theme }) => theme.colors.black};
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.greySoftLight};
    opacity: 1;
  }

  &:focus::placeholder {
    opacity: 0;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;
